import { render, staticRenderFns } from "./orderManage.vue?vue&type=template&id=8e9e6d2a&scoped=true&"
import script from "./orderManage.vue?vue&type=script&lang=js&"
export * from "./orderManage.vue?vue&type=script&lang=js&"
import style0 from "./orderManage.vue?vue&type=style&index=0&id=8e9e6d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9e6d2a",
  null
  
)

export default component.exports